(function () {
  var toggle = document.querySelector('[data-menu-toggle]');
  var menu = document.querySelector('[data-mobile-menu]');
  if (toggle && menu) {
    var closed = ['grid-rows-[0fr]', 'opacity-0', 'pointer-events-none'];
    var open = ['grid-rows-[1fr]', 'opacity-100'];
    toggle.addEventListener('click', function () {
      var isOpen = menu.classList.contains('grid-rows-[1fr]');
      if (isOpen) {
        open.forEach(function (c) { menu.classList.remove(c); });
        closed.forEach(function (c) { menu.classList.add(c); });
        toggle.setAttribute('aria-expanded', 'false');
      } else {
        closed.forEach(function (c) { menu.classList.remove(c); });
        open.forEach(function (c) { menu.classList.add(c); });
        toggle.setAttribute('aria-expanded', 'true');
      }
    });
  }

  function refreshCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  var form = document.getElementById('ProductForm');
  if (form) {
    form.addEventListener('submit', function (e) {
      var addBtn = form.querySelector('[data-add-to-cart]');
      if (document.activeElement && document.activeElement.name !== 'add') return;
      e.preventDefault();
      addBtn.disabled = true;
      addBtn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          id: form.querySelector('[data-variant-id]').value,
          quantity: parseInt(form.querySelector('[data-qty-input]').value || '1', 10)
        })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          refreshCartCount();
          addBtn.textContent = 'Added ✓';
          setTimeout(function () { window.location.href = '/cart'; }, 500);
        })
        .catch(function () {
          addBtn.disabled = false;
          addBtn.textContent = 'Add to Cart';
        });
    });
  }
})();
